import React from 'react';
import { useMediaQuery } from 'react-responsive';

import bannerPurpleMetricsWeb from 'assets/images/banner-purple-metrics-web.png';
import bannerPurpleMetricsMobile from 'assets/images/banner-purple-metrics-mobile.png';

import { ImageBannerPurpleMetrics, LinkPurpleMetrics } from '../styles';

type HomeBannerCarouselProps = {
  brandSurveyUrl: string;
};

const HomeBannerCarousel = ({
  brandSurveyUrl,
}: HomeBannerCarouselProps): JSX.Element => {
  const isMobile = useMediaQuery({ maxWidth: 620 });

  return (
    <LinkPurpleMetrics
      href={brandSurveyUrl}
      rel="noreferrer"
      target="_blank"
      aria-label="Pesquisa de marca — abre em nova aba"
    >
      <ImageBannerPurpleMetrics
        src={isMobile ? bannerPurpleMetricsMobile : bannerPurpleMetricsWeb}
        alt="Pesquisa de marca — abre em nova aba"
      />
    </LinkPurpleMetrics>
  );
};

export default HomeBannerCarousel;
